import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { BRAND_COLORS } from '../../styles/theme';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Loading...'
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        gap: 2
      }}
    >
      <CircularProgress size={60} sx={{ color: BRAND_COLORS.forestGreen.main }} />
      <Typography variant="h6" sx={{ color: BRAND_COLORS.forestGreen.main }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
